import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	ChangeDetectorRef,
	AfterViewInit,
	ChangeDetectionStrategy,
	DoCheck,
} from "@angular/core";
import {
	getForm,
	// getFacilitiesForm,
	getSpocContactInfo,
} from "./adding-tc.component.element";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { Helpers } from "projects/training-calendar/src/app/helpers";
import { TrainingCentersService } from "projects/services/src/app/API/training-centers.service";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
	IAddressOptions,
	STATE,
	AddressOptions,
	FormGroupInterface,
} from "../../types";
import { IDFormControl, DFormHelpers } from "../../d-form/d-form.helpers";
import { TrainingPartnerService } from "projects/services/src/app/API/training-partner.service";
import { SharedService } from "projects/services/src/app/shared/shared.service";
declare var swal: any;
declare var toastr: any;
import * as moment from "moment";
import { ROUTE } from "projects/training-partner/src/app/training-partner/constants";
import { CurrentUserService } from "projects/services/src/app/current-user.service";
import { RegistrationService } from "projects/services/src/app/API/registration.service";
import { FileService } from 'projects/services/src/app/API/document/file.service';
import { FileUpload } from "../../file-upload/file-upload.component";

const REVIEWS = Object.freeze({
	RECOMMEND: "approved",
	NOT_RECOMMEND: "Not Approved",
	SEND_BACK: "Not Approved",
});

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: "app-adding-tc",
	templateUrl: "./adding-tc.component.html",
	styleUrls: ["./adding-tc.component.css"],
})
export class AddingTcComponent implements OnInit, DoCheck {
	forms: FormGroupInterface;
	disable: Boolean = true;
	disableWhenApproved: Boolean = false;
	label: string;
	// facilityForms: any = {};
	spocForm: any = {};
	sectorTargets: any = [];
	trainingCentreName: string;
	@Input() isAdmin: any;
	amdinNstate: any;
	@Input() trainingCenterType: string;
	validationCheck = false;
	requiredFacilities: any = {};
	selectedSchemeId: string;
	infoFormControl: IDFormControl;
	readonly STATE = STATE;
	spocFormControl: IDFormControl;
	@Input() state: any = this.STATE.FILLING;
	@Input() tpId?: string;
	facilityOptions: any;
	tcForms: any;
	isValid = false;
	uploadCategories = {
		trainingRoomPhotos: [],
		laboratoryRoomPhotos: [],
		maleWashroomRoomPhotos: [],
		femaleWashroomRoomPhotos: [],
		unisexWashroomRoomPhotos: [],
		cafetariaRoomPhotos: [],
	};
	exceptCommentValidation = [REVIEWS.RECOMMEND];
	dataLoaded = false;
	// addressOptions: IAddressOptions = {
	// 	isPlane: false,
	// 	fields: {
	// 		detail: true,
	// 		city: true,
	// 		district: true,
	// 		landmark: true,
	// 		pincode: true,
	// 		parliamentaryConstituency: true,
	// 		state : true,
	// 		tehsil: true
	// 	}
	// };
	addressOptions = new AddressOptions({
		isPlane: false,
		schemeType: "feeBased",
		required: {
			geoLocation: true,
		},
		fields: {
			detail: true,
			city: true,
			district: true,
			landmark: true,
			pincode: true,
			parliamentaryConstituency: true,
			state: true,
			tehsil: true,
			geoLocation: true,
			addressProof: true,
			addressProofType: true,
		},
	});
	validity: any = {
		infoForm: false,
		spocForm: false,
		facilityForm: true,
		addressForm: false,
		sectorTargetForm: false,
	};
	data: any = {
		infoForm: {},
		spocForm: {},
		facilityForm: {},
		address: {},
	};
	inforFormFnBuffer = [];
	addressForm: FormGroup;
	buffer = {
		spocFormFnBuffer: [],
	};
	preserveTrainingCentre: any = {};
	@Output() submit = new EventEmitter();
	@Output() resubmit = new EventEmitter();
	@Output() cancel = new EventEmitter();

	reviewCommentsOptions: any = [
		{
			name: "Approved",
			value: REVIEWS.RECOMMEND,
		},
		{
			name: "Not Approved",
			value: REVIEWS.SEND_BACK,
		},
		// {
		// 	name: 'Send Back',
		// 	value: REVIEWS.SEND_BACK
		// }
	];
	tcForm: FormGroup;
	isSchemeIdGrameenUdhyami = false;
	verifyOTPForm: FormGroup
	forJSS = false;
	isClicked = false;
	currentUser: any;
	tpState: string;
	tpDistrict: string;
	documents: FormGroup;
	fileType: FileUpload = {
		type: ['png', 'jpg', 'jpeg'], size: 200000, placeholder: 'Choose File', required: true,
		defaultMessage: 'File size upto 200kb (Allowed formats jpg, png, jpeg)', fieldName: 'Relevant Image Proof',
	};
	imgDocs: any;
	schemeReferenceId: any;
	isIndiaSkillsScheme = false;

	constructor(
		private formBuilder: FormBuilder,
		private trainingcentreservice: TrainingCentersService,
		public activatedRoute: ActivatedRoute,
		private trainingPartnerService: TrainingPartnerService,
		private sharedService: SharedService,
		private cdr: ChangeDetectorRef,
		private router: Router,
		private currentUserService: CurrentUserService,
		private registrationService: RegistrationService,
		private fileService: FileService
	) {
		console.log(this.activatedRoute.snapshot.params);
		this.schemeReferenceId = this.activatedRoute.snapshot.params.schemeReferenceId ? this.activatedRoute.snapshot.params.schemeReferenceId : this.activatedRoute.snapshot.queryParams.schemeReferenceId;
		if (this.schemeReferenceId === 'Scheme_1298') {
			this.isIndiaSkillsScheme = true;
			this.getUserDetails();
		}
		if (this.activatedRoute.snapshot.params && this.activatedRoute.snapshot.params.selectedSubSchemeName == 'Grameen Udhyami') {
			this.isSchemeIdGrameenUdhyami = true;
		} else if (this.activatedRoute.snapshot.params && this.activatedRoute.snapshot.params.forJSS === "true") {
			this.forJSS = true;
			this.getUserDetails();
		}

	}

	get value() {
		const address = this.toOutgoingAddress(this.data.address.address);
		const infoForm = this.infoFormControl.value();
		const spocForm = this.data.spocForm;
		const facilityForm = this.data.facilityForm;
		const value = Object.assign(
			{},
			infoForm,
			spocForm,
			facilityForm,
			{
				address,
			},
			{
				sectorTargets: this.sectorTargets,
			}
		);
		return value;
	}
	reviewComments: any;
	tcId: any;
	trainingCentre: any = {};
	formData = false;

	private runInfoForm(fn) {
		this.inforFormFnBuffer.push(fn);
	}

	private createFacilityOptions(tcType, isSchemeIdGrameenUdhyami: Boolean, validationPatch?: any,) {
		validationPatch = validationPatch || {};
		switch (tcType) {
			case "Fixed": {
				this.facilityOptions = [
					"internetConnectivity",
					"avVideoConFacility",
					"library",
					"staffRoom",
					"cafetariaDiningRoom",
					"physicalDisabledFriendly",
					"parkingFacility",
					"threePhasePowerConnection",
					"powerBackupFacility",
					"fireSafetyEquipment",
					"firstAidKitAvailability",
					"counsellingRoomPlacementCell",
					"residentialTraining",
					"cctvFacility",
					"biometricTrainingAttendance",
					"nsdcBrandingCentralFacade",
					"nsdcBrandingCentreReception",
					"nsdcBrandingClassroom",
					"nsdcBrandingOthers",
				];
				this.requiredFacilities = isSchemeIdGrameenUdhyami || this.schemeReferenceId === 'Scheme_1284' ? {} :
					{
						internetConnectivity: true,
						fireSafetyEquipment: true,
						firstAidKitAvailability: true,
						nsdcBrandingCentralFacade: true,
						nsdcBrandingCentreReception: true,
						nsdcBrandingClassroom: true,
					};
				validationPatch.maximumStudentsPerBatchAllowed = 40;
				break;
			}
			case "Temporary":
			case "Mobile": {
				validationPatch.maximumStudentsPerBatchAllowed = 200;
				this.facilityOptions = [
					"internetConnectivity",
					"avVideoConFacility",
					"library",
					"staffRoom",
					"cafetariaDiningRoom",
					"physicalDisabledFriendly",
					"parkingFacility",
					"threePhasePowerConnection",
					"powerBackupFacility",
					"fireSafetyEquipment",
					"firstAidKitAvailability",
					"counsellingRoomPlacementCell",
					"residentialTraining",
					"cctvFacility",
					"biometricTrainingAttendance",
					"nsdcBrandingCentralFacade",
					"nsdcBrandingCentreReception",
					"nsdcBrandingClassroom",
					"nsdcBrandingOthers",
				];
				this.requiredFacilities = isSchemeIdGrameenUdhyami || this.schemeReferenceId === 'Scheme_1284' ? {} : {
					// internetConnectivity: true,
					// fireSafetyEquipment: true,
					// firstAidKitAvailability: true,
					nsdcBrandingCentralFacade: true,
					// nsdcBrandingCentreReception: true,
					// nsdcBrandingClassroom: true
				};
				break;
			}
		}
	}

	private getNotRequiredFilds(tcType, validationPatch?: any) {
		validationPatch = validationPatch || {};
		switch (tcType) {
			case "Fixed": {
				return {
					trainingCentreName: false,
					geographicalLocation: false,
					ownership: false,
					franchiseDocuments: false,
					duration: false,
					centreCarpetArea: false,
					totalCapacity: false,
					totalNumberOfTrainingRooms: false,
					totalNumberOfLabs: false,
					numberOfMaleWashRooms: false,
					numberOfFemaleWashRooms: false,
					numberOfTransGenderWashRooms: false,
					distanceFromNearestAirport: false,
					distanceFromNearestTrainStation: false,
					distanceFromNearestCityCenter: false,
					totalNumberOfTrainingRoomsPhotos: false,
					totalNumberOfLabsPhotos: false,
					numberOfMaleWashRoomsPhotos: false,
					numberOfFemaleWashRoomsPhotos: false,
					numberOfTransGenderWashRoomsPhotos: false,
				};
			}
			case "Temporary": {
				return {
					trainingCentreName: false,
					geographicalLocation: false,
					ownership: false,
					franchiseDocuments: false,
					duration: false,
					centreCarpetArea: false,
					totalCapacity: false,
					totalNumberOfTrainingRooms: true,
					totalNumberOfLabs: true,
					numberOfMaleWashRooms: true,
					numberOfFemaleWashRooms: true,
					numberOfTransGenderWashRooms: true,
					distanceFromNearestAirport: false,
					distanceFromNearestTrainStation: false,
					distanceFromNearestCityCenter: false,
					totalNumberOfTrainingRoomsPhotos: true,
					totalNumberOfLabsPhotos: true,
					numberOfMaleWashRoomsPhotos: true,
					numberOfFemaleWashRoomsPhotos: true,
					numberOfTransGenderWashRoomsPhotos: true,
				};
			}
		}
	}

	ngOnInit() {
		this.verifyOTPForm = this.formBuilder.group(
			{
				'mobileOTP': ['', [Validators.required, Validators.pattern('[0-9]{6}'), Validators.maxLength(6)]],
				'emailOTP': ['', [Validators.required, Validators.pattern('[0-9]{6}'), Validators.maxLength(6)]]
			});

		if (this.activatedRoute.snapshot.params && this.activatedRoute.snapshot.params.selectedSchemeId == '2044') {
			this.isSchemeIdGrameenUdhyami = true;
		}
		this.isAdmin = this.isAdmin === "true" ? true : false;
		this.state = this.isAdmin ? this.STATE.REVIEWING : this.state;
		this.amdinNstate = { admin: this.isAdmin, state: this.state };
		const data = {
			trainingCentreStatusOptions: ["a", "b"],
			centreOwnershipOptions: ["b", "c"],
			trainingCenterType: this.trainingCenterType,
			schemeId: this.schemeReferenceId
		};
		const validationPatch: any = {};
		if (
			this.activatedRoute.snapshot.params.state &&
			this.activatedRoute.snapshot.params.state === "viewing"
		) {
			this.disable = false;
		}
		this.runInfoForm(() =>
			this.infoFormControl.hideFields(["types", "centerOwnership"])
		);
		this.createFacilityOptions(this.trainingCenterType, this.isSchemeIdGrameenUdhyami, validationPatch);

		if (this.state !== this.STATE.FILLING) {
			this.activatedRoute.params.subscribe((param: Params) => {
				this.tcId = param["tcId"];
				this.trainingcentreservice
					.getTrainingCentre(this.tcId)
					.subscribe(
						(trainingCentre) => {
							this.trainingCentre = trainingCentre;
							data.schemeId = trainingCentre.schemeId;
							this.imgDocs = trainingCentre.imageUrls;
							// if(this.isAdmin){
							// 	this.documents.patchValue(this.imgDocs);
							// }
							// const cmaReview = trainingCentre.cmaReviews.length - 1;
							// trainingCentre.cmaReviews.filter((ele, cmaReview) => {
							// 	console.log(ele, cmaReview, this.infoFormControl);
							// 	if (ele.review.formSectionReview.review == 'approved') {

							// 	}
							// })
							if (
								this.trainingCentre.residentialFacilities &&
								this.trainingCentre.residentialFacilities
									.centreCarpetArea
							) {
								this.trainingCentre.residentialFacilities.totalCapacity =
									// tslint:disable-next-line:max-line-length
									this.sharedService.centreAreaChange(
										this.trainingCentre
											.residentialFacilities
											.centreCarpetArea,
										this.trainingCentre.createdOn ||
										new Date()
									);
							} else {
								if (
									this.trainingCentre &&
									this.trainingCentre.residentialFacilities &&
									this.trainingCentre.residentialFacilities
										.totalCapacity
								) {
									this.trainingCentre.residentialFacilities[
										"totalCapacity"
									] = 0;
								}
							}
							this.createFacilityOptions(
								this.trainingCentre.trainingCenterType, this.isSchemeIdGrameenUdhyami
							);
							this.dataLoaded = true;
							this.preserveTrainingCentre =
								Helpers.copyObj(trainingCentre);
							// Review Format
							const cmaReviews =
								trainingCentre && trainingCentre.cmaReviews;
							const copyReview = [];
							Helpers.copyArray(copyReview, cmaReviews);
							const latestCmaAction = copyReview.pop();
							const latestCmaReviewComment =
								latestCmaAction &&
								latestCmaAction.review &&
								JSON.parse(latestCmaAction.review);
							this.reviewComments = latestCmaReviewComment && {
								review:
									latestCmaReviewComment &&
									latestCmaReviewComment.formSectionReview &&
									latestCmaReviewComment.formSectionReview
										.review,
								comment:
									latestCmaReviewComment &&
									latestCmaReviewComment.formSectionReview &&
									latestCmaReviewComment.formSectionReview
										.comment,
							};
							// Getting Scheme Id
							if (
								trainingCentre.associations &&
								typeof trainingCentre.associations ===
								"object" &&
								trainingCentre.associations.length !== 0
							) {
								const associations =
									trainingCentre.associations;
								// this.selectedSchemeId =
								// 	associations[0].schemeId;
							}
							this.activatedRoute.queryParams.subscribe((queryParams) => {
								this.selectedSchemeId = queryParams["selectedSchemeId"];
							});
							// Format TC Data
							if (this.trainingCentre.residentialFacilities) {
								this.trainingCentre.numberOfMaleWashRooms =
									this.trainingCentre.residentialFacilities.men.numberOfWashRooms;
								this.trainingCentre.numberOfFemaleWashRooms =
									this.trainingCentre.residentialFacilities.women.numberOfWashRooms;
								this.trainingCentre.numberOfTransGenderWashRooms =
									this.trainingCentre.residentialFacilities.transgender.numberOfWashRooms;
							}
							Helpers.copyArray(
								this.sectorTargets,
								this.trainingCentre.sectorTargets
							);
							Object.assign(this.trainingCentre, data);
							console.log(
								this.trainingCentre,
								"training centre data"
							);

							this.checkTrainingCentreLocation(
								this.trainingCentre
							);
							this.formData = true;
							const temporary = {};
							if (
								this.trainingCentre.trainingCenterType ===
								"Temporary"
							) {
								Object.assign(temporary, {
									temporary: true,
								});
							}
							// Create TC Form
							this.data.address = this.toIncomingAddress(
								this.trainingCentre.address
							);
							const fieldsNotRequired = this.getNotRequiredFilds(
								this.trainingCentre.trainingCenterType
							);
							this.forms = getForm(
								Object.assign(
									{},
									this.trainingCentre,
									validationPatch
								),
								{
									centreOwnershipChange:
										this.onCenterOwnershipChange.bind(this),
									tcFromDateChange:
										this.onTcFromDateDurationChange.bind(
											this
										),
									onTrainingRoomPhotosCategoryChange:
										this.onTrainingRoomPhotosCountChange.bind(
											this
										),
									onLaboratoryRoomCountChange:
										this.onLaboratoryRoomPhotosCountChange.bind(
											this
										),
									onMaleWashroomCountChange:
										this.onMaleWashroomCountChange.bind(
											this
										),
									onFemalWashroomCountChange:
										this.onFemalWashroomCountChange.bind(
											this
										),
									onUnisexWashroomCountChange:
										this.onUnisexWashroomCountChange.bind(
											this
										),
									centreAreaChange:
										this.centreAreaChange.bind(this),
								},
								fieldsNotRequired,
								temporary,
								this.isSchemeIdGrameenUdhyami,
								this.forJSS,
								this.isIndiaSkillsScheme
							);
							// if (this.reviewComments.review == 'approved') {
							// 	console.log(this.forms)
							// 	this.forms.forms.filter(form => {
							// 		form.formElements.filter((ele) => {
							// 			ele.disabled = true;
							// 			this.disableWhenApproved = true;
							// 		});
							// 	})
							// }

							this.spocForm = getSpocContactInfo(
								{
									spoc: this.trainingCentre.spoc,
									trainingCentreCategories:
										this.uploadCategories
											.trainingRoomPhotos,
									laboratoryRoomCategories:
										this.uploadCategories
											.laboratoryRoomPhotos,
									photos: this.trainingCentre.photos,
								},
								{},
								fieldsNotRequired
							);
							const elemensToBeDisabled = ["firstName"];
							this.spocForm.forms[0].formElements.filter(
								(ele) => {
									ele.disabled = false;
								}
							);
							if (
								this.trainingCentre.status ===
								"Document Required"
							) {
								this.isValid = true;
							}
							console.log(this.spocForm);
							if (
								this.trainingCentre.status ===
								"Document Required" &&
								this.reviewComments.review === "approved"
							) {
								// this.disableWhenApproved = true;
								this.forms.forms.filter((formElement) => {
									formElement.formElements.filter((ele) => {
										ele.disabled = true;
									});
								});
							}
							Helpers.mapObject(this, {
								"trainingCentre.photos.trainingRoomPhotos":
									"trainingCentre.photos.trainingRoomPhotos",
								"trainingCentre.photos.":
									"trainingCentre.photos.laboratoryRoomCategories",
							});
							this.uploadCategories.trainingRoomPhotos =
								Object.keys(
									this.trainingCentre.photos
										.trainingRoomPhotos || {}
								);
							this.uploadCategories.laboratoryRoomPhotos =
								Object.keys(
									this.trainingCentre.photos
										.laboratoryRoomPhotos || {}
								);
							// this.data.address = this.toIncomingAddress(this.trainingCentre.address);
							if (
								!this.isAdmin &&
								this.reviewComments &&
								this.reviewComments.review &&
								this.reviewComments.review ===
								REVIEWS.RECOMMEND &&
								!this.activatedRoute.snapshot.params.state
							) {
								// this.disableWhenApproved = true;
							} else {
								this.disableWhenApproved = false;
							}
						},
						(err) => {
							console.log("error", err);
						}
					);
			});
		} else {
			this.dataLoaded = true;
			this.activatedRoute.params.subscribe((param: Params) => {
				this.selectedSchemeId = param["selectedSchemeId"];
			});
			this.addressForm = this.formBuilder.group({});
			const fieldsNotRequired = this.getNotRequiredFilds(
				this.trainingCenterType
			);
			const temporary = {};
			if (this.trainingCenterType === "Temporary") {
				Object.assign(temporary, {
					temporary: true,
				});
			}
			this.forms = getForm(
				Object.assign({}, data, validationPatch),
				{
					centreOwnershipChange:
						this.onCenterOwnershipChange.bind(this),
					onTrainingRoomPhotosCategoryChange:
						this.onTrainingRoomPhotosCountChange.bind(this),
					onLaboratoryRoomCountChange:
						this.onLaboratoryRoomPhotosCountChange.bind(this),
					onMaleWashroomCountChange:
						this.onMaleWashroomCountChange.bind(this),
					onFemalWashroomCountChange:
						this.onFemalWashroomCountChange.bind(this),
					onUnisexWashroomCountChange:
						this.onUnisexWashroomCountChange.bind(this),
					centreAreaChange: this.centreAreaChange.bind(this),
				},
				fieldsNotRequired,
				temporary,
				this.isSchemeIdGrameenUdhyami,
				this.forJSS
			);
			// this.makeFieldsValid(this.trainingCenterType);
			// this.facilityForms = getFacilitiesForm();
			this.spocForm = getSpocContactInfo(
				{
					trainingCentreCategories:
						this.uploadCategories.trainingRoomPhotos,
				},
				{},
				fieldsNotRequired
			);
			this.label = this.forms.label;
			this.formData = true;
			if (this.trainingCenterType === "Temporary") {
				this.runInfoForm(() =>
					this.infoFormControl.hideFields([
						"distanceFromNearestAirport",
					])
				);
				this.runInfoForm(() =>
					this.infoFormControl.hideFields([
						"distanceFromNearestTrainStation",
					])
				);
				this.runInfoForm(() =>
					this.infoFormControl.hideFields([
						"distanceFromNearestCityCenter",
					])
				);
			}
		}

		if (this.trainingCenterType === 'Online' || (this.forJSS && this.data.trainingCenterType === 'JSS Sub Center') || (this.isAdmin && this.trainingCenterType === 'JSS Sub Center')) {
			this.runInfoForm(() =>
				this.infoFormControl.hideFields([
					"ownership", "typeOfTC", "franchiseDocuments",
					"geographicalLocation", "centreCarpetArea",
				])
			);
			this.runInfoForm(() =>
				this.infoFormControl.disableFields(["trainingCentreName", "centerOwnershipType"])
			)

			this.addressOptions.required = {
				geoLocation: false,
				addressProofType: true,
				addressProof: true,
			}

			this.addressOptions.fields = {
				geoLocation: false,
				addressProofType: true,
				addressProof: true,
			}
		}
		if (this.forJSS) {
			this.createDocumentForm();
		}

		if (this.schemeReferenceId === 'Scheme_1284') {
			this.addressOptions.required = {
				geoLocation: false,
			}
		}
	}

	centreAreaChange(data) {
		if (
			this.forms &&
			this.forms.forms &&
			this.forms.forms[0].formRef &&
			this.forms.forms[1].formRef
		) {
			const date = new Date(
				this.forms.forms[0].formRef.get("startDate").value
			);
			const startDate = moment(date, "DD-MM-YYYY");
			const endDate = moment(
				`31-03-${date.getFullYear() + 1}`,
				"DD-MM-YYYY"
			);
			let actualDays = endDate.diff(startDate, "days") + 1;
			actualDays = (actualDays * 72) / 100;
			let capacity = data;
			if (capacity && capacity >= 1000) {
				capacity = capacity - (capacity * 20) / 100;
			}
			capacity = (capacity * 2) / 10;
			capacity = Math.round((capacity * actualDays) / 90);
			if (capacity && this.forms.forms[1].formRef.get("totalCapacity")) {
				this.forms.forms[1].formRef
					.get("totalCapacity")
					.setValue(capacity);
			}
		}
	}

	onWashroomCountChange() {
		const data = this.infoFormControl.value();
		const totalNumberOfWashroom =
			data.numberOfMaleWashRooms +
			data.numberOfFemaleWashRooms +
			data.numberOfTransGenderWashRooms;
		// console.log(data)
		this.infoFormControl.patchValues({
			totalNumberOfWashroom: totalNumberOfWashroom,
		});
	}

	onMaleWashroomCountChange(count) {
		console.log(count);
		this.onWashroomCountChange();
		const categories = [];
		for (let i = 1; i <= count; i++) {
			categories.push(i.toString());
		}
		if (count === 0) {
			this.runInfoForm(() =>
				this.spocFormControl.hideFields(["maleWashroomRoomPhotos"])
			);
			// return
		}
		// else {
		// 	this.changeCategoriesInSpoc('maleWashroomRoomPhotos', categories);
		// }
	}
	onFemalWashroomCountChange(count) {
		this.onWashroomCountChange();
		const categories = [];
		for (let i = 1; i <= count; i++) {
			categories.push(i.toString());
		}
		if (count === 0) {
			this.runInfoForm(() =>
				this.spocFormControl.hideFields(["femaleWashroomRoomPhotos"])
			);
			// return;
		}
		// else {
		// 	this.changeCategoriesInSpoc('femaleWashroomRoomPhotos', categories);
		// }
	}
	onUnisexWashroomCountChange(count) {
		this.onWashroomCountChange();
		const categories = [];
		for (let i = 1; i <= count; i++) {
			categories.push(i.toString());
		}
		if (count === 0) {
			this.runInfoForm(() =>
				this.spocFormControl.hideFields(["unisexWashroomRoomPhotos"])
			);
			// return;
		}
		// else {
		// 	this.changeCategoriesInSpoc('unisexWashroomRoomPhotos', categories);
		// }
	}
	onTrainingRoomPhotosCountChange(count) {
		const categories = [];
		for (let i = 1; i <= count; i++) {
			categories.push(i.toString());
		}
		if (count === 0) {
			this.runInfoForm(() =>
				this.spocFormControl.hideFields(["trainingRoomPhotos"])
			);
			// return;
		}
		// else {
		// 	this.changeCategoriesInSpoc('trainingRoomPhotos', categories);
		// }
	}

	onLaboratoryRoomPhotosCountChange(count) {
		const categories = [];
		for (let i = 1; i <= count; i++) {
			categories.push(i.toString());
		}
		if (count === 0) {
			this.runInfoForm(() =>
				this.spocFormControl.hideFields(["laboratoryRoomPhotos"])
			);
			// return;
		}
		// else {
		// 	this.changeCategoriesInSpoc('laboratoryRoomPhotos', categories);
		// }
	}

	changeCategoriesInSpoc(fieldName: string, categories: string[]) {
		const fnc = () => {
			const formElement = this.spocFormControl.getFormElement(fieldName);
			formElement.categories = categories;
			this.spocFormControl.resetFields([fieldName]);
		};
		if (this.spocFormControl) {
			fnc();
		} else {
			this.buffer.spocFormFnBuffer.push(fnc);
		}
	}

	private onTcFromDateDurationChange() { }

	private toOutgoingAddress(address) {
		address = Helpers.copyObj(address);
		Helpers.mapObject(address, {
			"location.longitude": "geoLocation.lng",
			"location.latitude": "geoLocation.lat",
			"location.formattedAddress": "geoLocation.formattedAddress",
		});
		address.addressProof = {
			type: address.addressProofType,
			locationURL: address.addressProof,
		};

		delete address.geoLocation;
		address.location.longitude = address && address.location && address.location.longitude ? address.location.longitude.toString() : null;
		address.location.latitude = address && address.location && address.location.latitude ? address.location.latitude.toString() : null;

		return address;
	}

	private toIncomingAddress(address) {
		address = Helpers.copyObj(address);
		Helpers.mapObject(address, {
			"geoLocation.lng": "location.longitude",
			"geoLocation.lat": "location.latitude",
			"geoLocation.formattedAddress": "location.formattedAddress",
		});
		address.addressProofType =
			address.addressProof && address.addressProof.type;
		address.addressProof =
			address.addressProof && address.addressProof.locationURL;

		delete address.location;
		return address;
	}

	onCenterOwnershipChange(ownership) {
		console.log(this.infoFormControl.value());
		this.trainingCenterType = this.trainingCenterType
			? this.trainingCenterType
			: this.trainingCentre.trainingCenterType;
		if (this.trainingCenterType === "Fixed") {
			switch (ownership) {
				case "Self Run": {
					this.runInfoForm(() =>
						this.infoFormControl.hideFields([
							"franchiseDocuments",
							"facultyType",
						])
					);
					this.runInfoForm(() =>
						this.infoFormControl.hideFields(["typeOfTC"], false)
					);
					break;
				}
				case "Franchise": {
					this.runInfoForm(() =>
						this.infoFormControl.hideFields(["typeOfTC"])
					);
					this.runInfoForm(() =>
						this.infoFormControl.hideFields(
							["franchiseDocuments"],
							false
						)
					);
					break;
				}
			}
		} else if (this.trainingCenterType === "Temporary") {
			switch (ownership) {
				case "Self Run": {
					this.runInfoForm(() =>
						this.infoFormControl.hideFields([
							"franchiseDocuments",
							"typeOfTC",
						])
					);
					this.runInfoForm(() =>
						this.infoFormControl.hideFields(
							["centerOwnership"],
							false
						)
					);
					break;
				}
				case "Franchise": {
					this.runInfoForm(() =>
						this.infoFormControl.hideFields(["typeOfTC"])
					);
					this.runInfoForm(() =>
						this.infoFormControl.hideFields(
							["franchiseDocuments", "centerOwnership"],
							false
						)
					);
					break;
				}
			}
		}
		console.log(ownership);
	}

	onSubmit(data) {
		if (this.forJSS && !this.documents.valid && !this.isIndiaSkillsScheme) {
			toastr.error("Please upload Infrastructure Images!");
			return;
		}
		console.log(this.value);
		this.isClicked = true;
		if (this.valid) {
			console.log(this.value);
			if (this.trainingCenterType === 'Online' || (this.forJSS && this.data.trainingCenterType === 'JSS Sub Center')) {
				const mobileNumber = Number(this.value.spoc.mobileNumber);
				this.registrationService.generateOTP("Training Centre", mobileNumber, this.value.spoc.email,'','','', this.forJSS)
					.subscribe((res) => {
						if (res) {
							this.isClicked = false;
							Helpers.openModal('verify-otp');
						}
					})
			} else {
				this.submitTrainingCenter();
			}
		} else {
			if (
				this.validity.addressForm &&
				this.validity.facilityForm &&
				this.validity.infoForm &&
				this.validity.spocForm &&
				!this.validity.sectorTargetForm
			) {
				toastr.error("Please fill Add Sector Target Form");
			} else {
				toastr.error("Please fill valid data!");
			}
			this.validationCheck = true;
			this.isClicked = false;
			this.forms.forms.filter((res) => {
				this.sharedService.markFormGroupTouched(res.formRef);
			});
			this.spocForm.forms.filter((res) => {
				this.sharedService.markFormGroupTouched(res.formRef);
			});
		}
	}

	verifyOTP() {
		if (this.verifyOTPForm.valid) {
			const otpDetails = {
				phone: this.verifyOTPForm.get('mobileOTP').value,
				email: this.verifyOTPForm.get('emailOTP').value,
			};
			const userData = {
				role: "Training Centre",
				spoc: {
					mobileNumber: Number(this.value.spoc.mobileNumber),
					email: this.value.spoc.email,
					firstName: this.value.spoc.firstName,
				}
			}
			this.registrationService.verifyOTP(otpDetails, userData)
				.subscribe(res => {
					if (res) {
						swal('Verified Successfully', '', 'success');
						Helpers.closeModal('verify-otp');
						this.submitTrainingCenter();
					}
				});
		} else {
			toastr.err("Please enter otp");
		}
	}

	submitTrainingCenter() {
		const trainingCentre = Helpers.copyObj(this.value);
		trainingCentre["typeOfTC"] = this.value["typeOfTC"];
		const user = this.currentUserService.getCurrentUserLocal().value;
		const tpId = this.tpId || user.userName;
		if (this.isSchemeIdGrameenUdhyami) {
			trainingCentre.submitForApproval = true;
		} else if (this.forJSS) {
			trainingCentre.forJSS = true;
		} else {
			trainingCentre.submitForApproval = false;
		}
		trainingCentre.trainingPartner = {
			id: user._id,
			userName: tpId,
			name: user.firstName,
		};
		trainingCentre.associations = [
			{
				schemeId: this.selectedSchemeId,
			},
		];
		trainingCentre.selectedSchemeId = this.selectedSchemeId;
		if (this.forJSS) {
			let images = this.documents.value;
			trainingCentre.imageUrls = images;
		}
		this.submit.emit(trainingCentre);
		this.isClicked = false;
	}

	onResubmit(data) {
		if (this.forJSS && !this.documents.valid) {
			toastr.error("Please upload Infrastructure Images!");
			return;
		}
		this.isClicked = true;
		if (this.valid) {
			const trainingCentre = Helpers.copyObj(this.value);
			const user = this.currentUserService.getCurrentUserLocal().value;
			// const user = JSON.parse(localStorage.getItem('loginUserData'));
			const tpId = this.tpId || user.userName;
			trainingCentre.trainingPartner = {
				id: user._id,
				userName: tpId,
				name: user.firstName,
			};
			trainingCentre.associations = [
				{
					schemeId: this.selectedSchemeId,
				},
			];
			trainingCentre.selectedSchemeId = this.selectedSchemeId;
			if (this.isSchemeIdGrameenUdhyami) {
				trainingCentre.submitForApproval = true;
			} else if (this.forJSS) {
				trainingCentre.forJSS = true;
			} else {
				trainingCentre.submitForApproval = false;
			}
			const tc = Object.assign(
				this.preserveTrainingCentre,
				trainingCentre
			);
			if (this.forJSS) {
				let images = this.documents.value;
				tc.imageUrls = images;
			}
			this.resubmit.emit(tc);
			this.isClicked = false;
		} else {
			this.validationCheck = true;
			if (
				this.validity.addressForm &&
				this.validity.facilityForm &&
				this.validity.infoForm &&
				this.validity.spocForm &&
				!this.validity.sectorTargetForm
			) {
				toastr.error("Please fill Add Sector Target Form");
			} else {
				toastr.error("Please fill valid data!");
			}
			this.isClicked = false;
			this.forms.forms.filter((res) => {
				this.sharedService.markFormGroupTouched(res.formRef);
			});
			this.spocForm.forms.filter((res) => {
				this.sharedService.markFormGroupTouched(res.formRef);
			});
		}
	}

	onCancel(data) {
		if (data) {
			data['isFromFormCancel'] = true;
		}
		this.cancel.emit(this.data);
	}

	onReviewSubmit(data) {
		const status = data.review;
		this.submit.emit({
			status,
			reviewComments: data,
		});
	}

	get reviewingOrViewing() {
		return (
			this.state === this.STATE.REVIEWING ||
			this.state === this.STATE.VIEWING
		);
	}

	onReviewCancel(data) {
		this.onCancel(data);
	}
	test(data) {
		console.log(data);
	}

	get valid() {
		const forms = Object.keys(this.validity);
		// if (!this.addressForm || !this.addressForm.valid) {
		if (!this.validity.addressForm) {
			// if (!this.addressForm || !this.addressForm.valid) {
			return true;
		}
		if (!this.validity.sectorTargetForm && this.isIndiaSkillsScheme) {
			// if (!this.addressForm || !this.addressForm.valid) {
			return true;
		}
		for (const form of forms) {
			if (!this.validity[form]) {
				return false;
			}
		}
		return true;
	}

	getPhotosReview(data) {
		this.onReviewSubmit(data);
	}

	onNavigate() {
		if (
			this.trainingCentre &&
			this.trainingCentre.schemes &&
			typeof this.trainingCentre === "object" &&
			this.trainingCentre.schemes.length !== 0
		) {
			const scheme = this.trainingCentre.schemes[0].schemeReferenceId;
			const tcListRoute = `${ROUTE.ADD_PHOTOS_TC_UPDATE}/${scheme}/${this.activatedRoute.snapshot.params.tcId}`;
			this.router.navigate([tcListRoute]);
		}
	}

	checkTrainingCentreLocation(data) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		const currentUserName = user.userName;

		const checkLocationData = {
			UserName: currentUserName,
			schemeId: this.selectedSchemeId,
			stateID: data.address.state && data.address.state.id,
			districts: data.address.district && data.address.district.id,
		};

		this.trainingPartnerService
			.checkTrainingCentreLocation(checkLocationData)
			.subscribe((resStatus) => {
				console.log(resStatus, "check location data");
				if (resStatus.message === "not found") {
					swal(
						"TC Location entered is different from Locations approved in the Project Details",
						"",
						"warning"
					);
				}
			});
	}
	ngDoCheck() {
		this.cdr.markForCheck();
	}

	checkBox(event) {
		console.log(event);
		if (event.target.checked) {
			this.isValid = false;
		} else {
			this.isValid = true;
		}
	}

	getUserDetails() {
		this.currentUserService.getCurrentUser().subscribe((res: any) => {
			this.currentUser = res;
			this.tpState = res?.address?.state || "";
			this.tpDistrict = res?.address?.districtDetails?.district || "";
		})
	}

	createDocumentForm() {
		this.documents = new FormGroup({
			imageOne: new FormControl("", Validators.required),
			imageTwo: new FormControl("", Validators.required),
			imageThree: new FormControl("", Validators.required),
			imageFour: new FormControl("", Validators.required),
		})
	}

	fileUploaded(event, control) {
		if (event.url) {
			this.fileService.getImageURL(event.url).subscribe(res => {
				this.documents.get(control).setValue(res);
				console.log(`${control}----->>>>`, res);
				toastr.info(`${event.name} file uploaded successfully`)
			})
		}
	}

	onFileUploadCancel(event, control) {
		this.documents.get(control).setValue("");
	}
}
